module.exports = __webpack_public_path__ + "static/media/fal_fal_cab_gua.4cfb45c4.png";